import * as yup from "yup";
import { ASSESSMENT_FORM_ENUMS } from "./form.util";

export const validationAssesmentSchema = yup.object().shape({
  [ASSESSMENT_FORM_ENUMS.rating]: yup.number().required("El rating es requerido"),
  [ASSESSMENT_FORM_ENUMS.comment]: yup.string().when(ASSESSMENT_FORM_ENUMS.rating, {
    is: 3,
    then: () =>
      yup
        .string()
        .required("Escribe un comentario de al menos 15 caracteres.")
        .min(15),
    otherwise: () => yup.string().nullable()
  })
});
